/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RemoteSessionIssuer,
  RemoteSessionIssuer$inboundSchema,
} from "./remotesessionissuer.js";

/**
 * Result type for listing remote_session_issuers.
 */
export type ListRemoteSessionIssuersResult = {
  items: Array<RemoteSessionIssuer>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListRemoteSessionIssuersResult$inboundSchema: z.ZodMiniType<
  ListRemoteSessionIssuersResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(RemoteSessionIssuer$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listRemoteSessionIssuersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListRemoteSessionIssuersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRemoteSessionIssuersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRemoteSessionIssuersResult' from JSON`,
  );
}
